import { Group, UnstyledButton } from '@mantine/core';
import { UI } from '../../theme/kioskTheme';

// Botones grandes de seleccion (§8.3: "botones grandes, nunca <select>").
// Estilos en linea a proposito: el Chip de Mantine se pinta con variables CSS
// propias que se comian el tema del kiosco. Aca no hay cascada que valga.
const BASE = {
  minHeight: 64,
  paddingInline: 26,
  borderRadius: 12,
  borderWidth: 2,
  borderStyle: 'solid',
  fontSize: 19,
  fontWeight: 600,
  fontFamily: 'Montserrat, sans-serif',
  lineHeight: 1.2,
  transition: 'background-color .12s, border-color .12s, color .12s',
};

const SIN_MARCAR = {
  ...BASE,
  background: '#FFFFFF',
  borderColor: UI.borde,
  color: UI.tinta,            // 10,6:1 sobre blanco
};

const MARCADO = {
  ...BASE,
  background: UI.accion,
  borderColor: UI.accion,
  color: '#FFFFFF',           // 8,9:1
  boxShadow: '0 2px 8px rgba(23,63,110,.16)',
};

/**
 * @param {{value:string,label:string}[]} options
 * @param {string|string[]} value
 * @param {(v:string|string[]) => void} onChange
 * @param {boolean} multiple  varias opciones a la vez
 */
export function OpcionesGrandes({ options, value, onChange, multiple = false }) {
  const seleccion = multiple ? (value || []) : value;
  const estaMarcada = v => (multiple ? seleccion.includes(v) : seleccion === v);

  const alTocar = (v) => {
    if (!multiple) return onChange(seleccion === v ? '' : v);
    return onChange(seleccion.includes(v)
      ? seleccion.filter(x => x !== v)
      : [...seleccion, v]);
  };

  return (
    <Group gap="sm">
      {options.map(o => {
        const marcada = estaMarcada(o.value);
        return (
          <UnstyledButton
            key={o.value}
            onClick={() => alTocar(o.value)}
            role={multiple ? 'checkbox' : 'radio'}
            aria-checked={marcada}
            style={marcada ? MARCADO : SIN_MARCAR}
          >
            {o.label}
          </UnstyledButton>
        );
      })}
    </Group>
  );
}
